
<div class="modal fade" id="{{roundFormId}}" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true" #roundModalDiv>
    <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h6 class="modal-title">Round</h6>
                <button type="button" #closeButton class="btn-close btn-sm" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="container-fluid">
                    <div class="row row-cols-lg-auto g-2 align-items-center mb-2">
                        <label class="col-form-label-sm">Loc:</label>
                        <div class="col-12">
                            <select name="locCode" class="form-select form-select-sm" [(ngModel)]="roundParameters.locCode" (change)="getDispatches()">
                                <option *ngFor="let item of locList" value="{{item.value}}">{{item.text}}</option>
                            </select>
                        </div>
                        <div class="col-12">
                            <button type="button" class="btn btn-sm btn-primary" (click)="clearFilters()">Clear Filters</button>
                        </div>
                        <div class="col-12">
                            <button type="button" class="btn btn-sm btn-primary" (click)="clearSorting()">Default Sort</button>
                        </div>
                    </div>
                    <div class="mb-2">
                        <pqgrid #dispatchGrid [options]="gridOptions"></pqgrid>
                    </div>

                    <div class="row row-cols-lg-auto g-2 align-items-center mb-2">
                        <label class="col-form-label-sm">Loads:</label>
                        <div class="col-12">
                            <input type="number" class="form-control form-control-sm" id="addDispatchloads" name="addDispatchloads"
                                   [disabled]="selectedDispatch.loadBreakout" [(ngModel)]="addDispatchLoads" [ngModelOptions]="{standalone: true}" style="width: 80px;" />
                        </div>
                        <div class="col-12">
                            <button type="button" class="btn btn-sm btn-primary" [disabled]="!dispatchSelected" (click)="addDispatch()">Add To Round</button>
                        </div>
                        <div class="col-12 text-primary" *ngIf="selectedDispatch.loadBreakout">
                            All loads for the selected dispatch must be added to the round because it has breakout by day loads.
                        </div>
                        <div class="col-12 text-danger">
                            {{addDispatchError}}
                        </div>
                    </div>

                    <div class="border border-rounded px-1 mb-2 table-responsive" style="height: 200px;">
                        <table class="table table-sm table-borderless scrollable">
                            <thead>
                                <tr>
                                    <th>&nbsp;</th>
                                    <th>&nbsp;</th>
                                    <th>Loc</th>
                                    <th>Origin Customer</th>
                                    <th>Origin</th>
                                    <th>Origin City</th>
                                    <th>Dest Customer</th>
                                    <th>Destination</th>
                                    <th>Dest City</th>
                                    <th>Comm</th>
                                    <th class="text-end">Loads</th>
                                    <th>&nbsp;</th>
                                    <th>Trucker</th>
                                    <th>Rate</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let dispatch of round.dispatches; let i = index">
                                    <td class="text-nowrap">
                                        <a href="#" title="move up" (click)="moveOrderUp(i, dispatch)"><i class="fa-solid fa-up-long fa-lg"></i></a>&nbsp;
                                        <a href="#" title="move down" (click)="moveOrderDown(i, dispatch)"><i class="fa-solid fa-down-long fa-lg"></i></a>
                                    </td>
                                    <td><a href="#" title="remove dispatch" (click)="removeDispatch(i, dispatch)"><i class="fa-solid fa-trash-can fa-lg"></i></a></td>
                                    <td>{{dispatch.locCode}}</td>
                                    <td>{{dispatch.customerName}}</td>
                                    <td>{{dispatch.originName}}</td>
                                    <td>{{dispatch.originCity}}</td>
                                    <td>{{dispatch.destinationCustomerName}}</td>
                                    <td>{{dispatch.destinationName}}</td>
                                    <td>{{dispatch.destinationCity}}</td>
                                    <td>{{dispatch.commodityCode}}</td>
                                    <td class="text-end">{{dispatch.loads}}</td>
                                    <td>&nbsp;</td>
                                    <td>{{dispatch.truckerName}}</td>
                                    <td>{{dispatch.rate}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="row g-2 mb-2">
                        <div class="col-sm-3">
                            <label class="form-label">Round Notes</label>
                            <textarea class="form-control form-control-sm" id="roundNotes" name="roundNotes" rows="4" [(ngModel)]="round.notes"></textarea>
                        </div>

                        <div class="col-sm-3">
                            <label class="form-label">Internal Comments</label>
                            <textarea class="form-control form-control-sm" id="roundComments" name="roundComments" rows="4" [(ngModel)]="round.internalComments"></textarea>
                        </div>
                        <div class="col-sm-4 position-relative">
                            <div #truckerSearchDropdown class="row g-1">
                                <div class="col-sm-3">
                                    <label class="form-label">Trucker</label>
                                    <button class="btn btn-sm btn-secondary dropdown-toggle w-100" type="button" (click)="toggleTruckerSearch()">
                                        Assign Trucker
                                    </button>
                                    <div *ngIf="showTruckerSearch">
                                        <div class="dropdown-search table-responsive border rounded shadow px-1">
                                            <table class="table table-sm table-borderless table-hover scrollable">
                                                <thead>
                                                    <tr [formGroup]="truckerSearchForm">
                                                        <th style="width: 45%;">
                                                            Trucker
                                                            <input type="text" class="form-control form-control-sm" formControlName="customerName" />
                                                        </th>
                                                        <th style="width: 35%;">
                                                            City
                                                            <input type="text" class="form-control form-control-sm" formControlName="city" />
                                                        </th>
                                                        <th style="width: 20%;">
                                                            Code
                                                            <input type="text" class="form-control form-control-sm" formControlName="customerCode" />
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let item of truckerList" (click)="selectTrucker(item)">
                                                        <td>{{item.customerName}}</td>
                                                        <td>{{item.city}}</td>
                                                        <td>{{item.customerCode}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-7">
                                    <label class="form-label">&nbsp;</label>
                                    <input type="text" class="form-control form-control-sm" id="trucker" name="trucker" placeholder="Trucker" disabled style="width: 300px;" value="{{round.truckerName}}" [class.border-danger]="formState.trucker.invalid" />
                                    <div *ngIf="formState.trucker.invalid" class="text-danger">
                                        {{formState.trucker.errorMessage}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <div class="d-block w-100">
                        <button type="button" class="btn btn-sm btn-danger float-start" (click)="deleteRound()" *ngIf="!isNew && formStatus == FormStatus.Normal">Delete Round</button>
                        <div class="float-end" *ngIf="formStatus == FormStatus.Delete || formStatus == FormStatus.Deleting">
                            <button type="button" class="btn btn-sm btn-danger me-2" (click)="confirmDelete()" *ngIf="formStatus == FormStatus.Delete">Confirm Delete</button>
                            <button type="button" class="btn btn-sm btn-danger me-2" disabled *ngIf="formStatus == FormStatus.Deleting">
                                <span class="spinner-border spinner-border-sm me-1"></span>
                                <span>Deleting...</span>
                            </button>
                            <button type="button" class="btn btn-sm btn-secondary" (click)="cancelDelete()" [disabled]="formStatus == FormStatus.Deleting">Cancel Delete</button>
                        </div>
                        <div class="float-end" *ngIf="formStatus == FormStatus.Normal || formStatus == FormStatus.Saving">
                            <button type="button" class="btn btn-sm btn-primary me-2" style="width: 100px;" (click)="saveRound(false)" *ngIf="formStatus == FormStatus.Normal">Save Round</button>
                            <button type="button" class="btn btn-sm btn-primary me-2" disabled *ngIf="formStatus == FormStatus.Saving">
                                <span class="spinner-border spinner-border-sm me-1"></span>
                                <span>Saving...</span>
                            </button>
                            <button type="button" class="btn btn-sm btn-secondary" style="width: 80px;" data-bs-dismiss="modal" [disabled]="formStatus == FormStatus.Saving">Cancel</button>
                        </div>
                        <div class="float-end" *ngIf="formStatus == FormStatus.ConfirmSave">
                            <span class="text-primary me-3" *ngIf="formState.dispatchTrucker.invalid">{{formState.dispatchTrucker.errorMessage}}</span>
                            <button type="button" class="btn btn-sm btn-secondary me-2" style="width: 100px;" (click)="cancelSave()">Cancel Save</button>
                            <button type="button" class="btn btn-sm btn-primary" style="width: 100px;" (click)="saveRound(true)">Confirm Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>





